import baseService from "services/base-service";
import {
  ISLPRequestsPayloadValues,
  IUpdateSLPContactNoteValue,
  IUpdateSLPContactProgressValue,
  IUpdateSLPParticipationValue,
  IViewSLPGoalsAssessmentPDFValue,
} from "utils/interfaces/slp";

const studentDashboardBaseUrl = "/api/SLP";

const getSLPRequests = async (payload: ISLPRequestsPayloadValues) =>
  baseService.post(`${studentDashboardBaseUrl}/GetSLPRequests`, payload);

const getPLAUserList = async () =>
  baseService.get(`${studentDashboardBaseUrl}/GetPLAUserList`);

const getSLPRequestsPDF = async (payload: ISLPRequestsPayloadValues) =>
  baseService.post(`${studentDashboardBaseUrl}/GetSLPRequestsPDF`, payload);

const updateSLPContactProgress = async (
  payload: IUpdateSLPContactProgressValue
) =>
  baseService.put(
    `${studentDashboardBaseUrl}/UpdateSLPContactProgress`,
    payload
  );

const getCompletedSLPList = async (payload: ISLPRequestsPayloadValues) =>
  baseService.post(`${studentDashboardBaseUrl}/GetCompletedSLPList`, payload);

const getCompletedSLPListPDF = async (payload: ISLPRequestsPayloadValues) =>
  baseService.post(
    `${studentDashboardBaseUrl}/GetCompletedSLPListPDF`,
    payload
  );

const updateSLPParticipation = async (payload: IUpdateSLPParticipationValue) =>
  baseService.put(`${studentDashboardBaseUrl}/UpdateSLPParticipation`, payload);

const updateSLPContactNote = async (payload: IUpdateSLPContactNoteValue) =>
  baseService.put(`${studentDashboardBaseUrl}/UpdateSLPContactNote`, payload);

const viewSLPGoalsAssessmentPDF = async (
  payload: IViewSLPGoalsAssessmentPDFValue
) =>
  baseService.post(
    `${studentDashboardBaseUrl}/GetSLPGoalsAssessmentPDF`,
    payload
  );

export default {
  getSLPRequests,
  getPLAUserList,
  getSLPRequestsPDF,
  updateSLPContactProgress,
  getCompletedSLPList,
  getCompletedSLPListPDF,
  updateSLPParticipation,
  updateSLPContactNote,
  viewSLPGoalsAssessmentPDF,
};
